import * as React from 'react';
import { DateTime } from 'luxon';

export type ShowDateProps = {
  date: string // ISO8601 formatted date
}

export function ShowDate(props: ShowDateProps) {
  if(props.date) {
    const dt = DateTime.fromISO(props.date);
    return(<span>{dt.toLocaleString(DateTime.DATE_MED)}</span>)
  }
  return(<span> - </span>)
}
